import { Dispatch } from 'react';
import { request } from './request';
import { SessionAction } from '../interfaces/Session';

interface GetMFATokenProps {
  token: string,
}

export function getMFAToken(dispatch: Dispatch<SessionAction>, props: GetMFATokenProps) {
  return request(dispatch, '/auth/mfatoken/' + props.token, {
    auth: false,
  });
}